import React from 'react'
import { Paper } from '@mui/material'

export default function MobileActionCard({ children, buttonHeight = 44 }) {
  return (
    <Paper
      elevation={0}
      variant="outlined"
      sx={{
        p: 2,
        borderRadius: 2,
        '& > div': { width: '100%' },
        '& .MuiButtonGroup-root': {
          width: '100%',
          display: 'flex'
        },
        '& .download-doble-reports': {
          flex: 1,
          minWidth: 0,
          width: 'auto',
          height: `${buttonHeight}px !important`
        },
        '& .download-doble-reports-arrow': {
          width: 42,
          minWidth: 42,
          flexShrink: 0,
          height: `${buttonHeight}px !important`
        },
        '& .download-doble-reports .MuiButton-startIcon': {
          mr: 0.75,
          ml: 0
        },
        '& .MuiButtonGroup-root > .MuiButton-root': {
          minHeight: `${buttonHeight}px`
        },
        '& > .MuiButton-root, & > div > .MuiButton-root': {
          minHeight: `${buttonHeight}px`
        }
      }}
    >
      {children}
    </Paper>
  )
}
